export default "__VITE_ASSET__DNS8p7X6__"